import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { DailySlotService } from 'src/app/services/daily-slot/daily-slot.service';
import { EventsService } from 'src/app/services/event/event.service';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Navigator } from 'src/app/components/menu/navigator';
import { ConfigService } from 'src/app/services/config/config.service';
import { WebcontentService } from 'src/app/services/webcontent/webcontent.service';
import { MobileDataService } from 'src/app/services/mobile-data/mobile-data.service';

@Component({
  selector: 'app-daily-slot',
  templateUrl: './daily-slot.component.html',
  styleUrls: ['./daily-slot.component.scss'],
})

export class DailySlotComponent implements OnInit {

  public slotUrl;
  private subscriber1: any;
  private subscriber2: any;
  private subscriber3: any;
  protected intervalID: any;
  @Input() availableSpins: any;

  constructor(
    public navCtrl: NavController,
    private dailySlotService: DailySlotService,
    public events: EventsService,
    public appLinks: AppLinksService,
    private navigator: Navigator,
    private config: ConfigService,
    private mobileData: MobileDataService,
    private webcontentService: WebcontentService,
  ) {}

  ionViewWillEnter() {
    this.subscriber1 = fromEvent(window, 'resize').pipe(
      debounceTime(100))
      .subscribe((event) => {
        this.updateCSS();
      });

    this.subscriber2 = fromEvent(window, 'scroll').pipe(
      debounceTime(100))
      .subscribe((event) => {
        this.updateCSS();
      });

    this.subscriber3 = fromEvent(window, 'message').pipe(
      debounceTime(100))
      .subscribe((event) => {
        this.oniFrameMessage(event);
      });

  }

  ngOnInit(): void {
    this.slotUrl = this.dailySlotService.getUrl(this.availableSpins);
    console.log("Daily Slot URL", this.slotUrl);
  }

  ionViewDidEnter() {
    this.events.publish("event:balanceState", { show: false, code: "IN_GAME" });

    this.updateCSS();
  }

  ionViewDidLeave() {
    this.subscriber1.unsubscribe();
    this.subscriber2.unsubscribe();
    this.subscriber3.unsubscribe();

    this.events.publish("event:balanceState", { show: true });
    this.events.publish("event:appInit:next");
  }

  oniFrameMessage(event) {
    if (!!(event.data) && !!(event.data.name)) {
      switch (event.data.name) {
        case "close_game":
          this.navigator.dismiss(); //@todo should be removed, at this point app-init has no listeners.
          const freeSpinRedirectPage: string = this.config?.getExternalLinks()?.payload?.filter(link => link?.code == 'FREE_SPIN_REDIRECT_PAGE')[0]?.url;
          this.webcontentService.updateExternalLink(freeSpinRedirectPage);
          this.navigator.toWebview(true, freeSpinRedirectPage);
          let key: object = {
            action_param: freeSpinRedirectPage,
            action_type: "externalpageload",
            name: "Free Spin"
          };

          this.mobileData.sendExternalSelection("null");
          break;
        case "show_terms_ios":
          let updateURL = event.data.termsURL
          this.appLinks.openExternalPage(updateURL);
          break;
        case "show_rules":
          let rulesURL = this.config.getConfig().FEATURE_DAILYSLOT_RULES;
          this.appLinks.popupToDialog(rulesURL);
          break;
      }
    }
  }

  updateCSS() {

    let modal = document.querySelectorAll('.custom-modal-class')[0];

    if (!!modal) {
      let top = window.scrollY > 0 ? window.scrollY : 0;
      let style = ` 
            width: ${window.innerWidth}px !important;
            height: ${window.innerHeight}px !important;
            left: 0px !important;
            top: 0px !important;
            margin-top: ${top}px !important;
            background: rgba(0, 0, 0, 0.3);
            opacity:1;
            --background: transparent;
            --width: ${window.innerWidth}px !important;
            --height: ${window.innerHeight}px !important;
        `;

      modal.setAttribute("style", style);
    }

    try {
      let modalwrapper: any = document.querySelectorAll('ion-modal')[0].shadowRoot.children[1];

      if (modalwrapper != null) {
        let style = ` 
                box-shadow: none !important;
            `;

        modalwrapper.setAttribute("style", style);
      }
    }
    catch {
      console.log("daily-slot: unable to locate shadowRoot.children[1]")
    }
  }
}
